import React, { useMemo } from "react";

import { PECScanData as PECScanDataModel } from "../../../../utils/models";
import { getPECColorCodes, getPECScanReadingColumns } from "../../../../utils/data";
import { getChunkedData } from "../../../../utils/utilities";

import ColorPreview from "../../../blocks/color-preview";
import CustomSection from "../../../custom-reports/custom-general/custom-section";
import GridItem from "../general/gridItem";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import classNames from "../pdf.module.scss";

interface PECScanDataProps extends PECScanDataModel {
  data: any[];
  showRemarkSection: boolean;
  totalScanData: number;
}

const PECScanData: React.FC<PECScanDataProps> = ({ readings, sectionName, nominalThickness, data, corrosionAllowance, scanLocation, limitation, totalScanData  }) => {
  const chunkedData = useMemo(() => {
    return getChunkedData(readings.circValues, 14);
  }, [readings.circValues]);

  return (
      <React.Fragment >
        {chunkedData.map((columns, index) => (
          <CustomSection key={index} sectionTitle="Data Sheet" sectionSubtitle={`Scan Data (${sectionName})`}>
              <div className="container-fluid overflow-hidden">
                  <GridItem title="Scan Name:" value={scanLocation} />
                  <GridItem title="Limitation:" value={limitation} />
                  <GridItem title="Number of Measurements:" value={totalScanData} />
              </div>
  
              <div className={classNames.pecScanTitle}>Readings</div>
              <div className={classNames.pecScanColorReading}>
                  <p className={classNames.pecScanColorReadingTitle}>Wall thickness values</p>
                  <ColorPreview colors={getPECColorCodes()} />
              </div>
  
              <div className="p-2 table-responsive">
                <PDFTablePage caption="Axial Values" data={data} columns={getPECScanReadingColumns(+nominalThickness, +corrosionAllowance, columns)} />
              </div>
          </CustomSection>
        ))}
      </React.Fragment>
  );
};

export default PECScanData;